import { imgUrl, imgSet } from "@/lib/api";

export default function Img({ src, size = "md", sizes = "(max-width: 768px) 100vw, 50vw", className = "", alt = "", eager = false }) {
  return (
    <img src={imgUrl(src, size)} srcSet={imgSet(src)} sizes={imgSet(src) ? sizes : undefined} alt={alt}
      loading={eager ? "eager" : "lazy"} decoding="async" className={className} />
  );
}
